import React, { ReactNode, createContext, useContext } from "react";
import { useActor, useInterpret } from "@xstate/react";
import { transactionMachine } from "./machine";

const useTransactionService = () => useInterpret(transactionMachine);

const TransactionContext = createContext<
  ReturnType<typeof useTransactionService>
>(null!);

interface TransactionProviderProps {
  children?: ReactNode;
}

export function TransactionProvider({
  children,
}: TransactionProviderProps): JSX.Element {
  const transactionService = useTransactionService();

  return (
    <TransactionContext.Provider value={transactionService}>
      {children}
    </TransactionContext.Provider>
  );
}

export const useTransactionMachine = () => {
  const transactionService = useContext(TransactionContext);

  const [state, send] = useActor(transactionService);

  return { state, send };
};
